import React, {useContext, useEffect, useState} from 'react';

import {AppContext} from '../../AppModule/Context';

import AnimatedLogoComponent from '../../components/common/genericComponents/animatedLogoComponent';
import SwitchButtonComponentV2 from '../../components/common/genericComponents/redesign/switchButtonComponentV2/switchButtonComponentV2';

import emailDigestService from '../../services/emailDigestService';

import VIDABOO_CONSTANTS from '../../config/consts';

import './emailOptOutScreen.css';

const EmailOptOutScreen = (props) => {
  const context = useContext(AppContext);

  const [isSubscribed, setIsSubscribed] = useState(true);

  useEffect(() => {
    context.setNotificationPopUpData({
      notificationTxt:
        'Are you sure you’d like to unsubscribe from weekly email summaries',
      notificationInfoTxt:
        'We’ll stop sending weekly digest emails once you unsubscribe',
      notificationType: VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.WARNING,
      closeBtnTxt: 'Cancel',
      closeBtnFunc: () => {
        context.closeNotificationPopUp();
      },
      rejectBtnTxt: 'Proceed',
      rejectBtnFunc: () => {
        updateSubscription(false);
        context.closeNotificationPopUp();
      },
    });
    context.setShowNotificationPopUp(true);
  }, []);

  const updateSubscription = (subscribe) => {
    const token = window.location.pathname?.split('/').pop();

    const showPopup = (message) => {
      context.setNotificationPopUpData({
        notificationTxt: message,
        notificationType: VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.WARNING,
        closeBtnTxt: 'Close',
        closeBtnFunc: () => {
          context.closeNotificationPopUp();
        },
      });
      context.setShowNotificationPopUp(true);
    };

    emailDigestService.updateEmailDigestSubscription(
      subscribe,
      token,
      () => {
        showPopup(
          `You have successfully ${subscribe ? 'subscribed to' : 'unsubscribed from'} weekly email summaries`,
        );
        setIsSubscribed(subscribe);
      },
      () => {
        showPopup(
          `You were unable to ${subscribe ? 'subscribed to' : 'unsubscribed from'} the weekly email digest. Please try again or contact us at info@consolto.com`,
        );
      },
    );
  };

  return (
    <div className="es-container">
      <div className="es-header">
        <div className="es-header-logo" onClick={() => props.history.push('/')}>
          <AnimatedLogoComponent />
        </div>
        <div className="es-header-title">
          Control your Consolto notifications
        </div>
      </div>
      <div className="es-body">
        <div className="es-unsubscribed-body">
          <div className="es-unsubscribe-body-heading">
            Notification settings
          </div>
          <div className="es-unsubscribe-body-flex-row">
            <div className="es-unsubscribe-body-sub-heading">
              Weekly email digest
            </div>
            <SwitchButtonComponentV2
              onClick={() => {
                if (isSubscribed) {
                  updateSubscription(false);
                } else {
                  updateSubscription(true);
                }
              }}
              switchState={
                isSubscribed
                  ? VIDABOO_CONSTANTS.SWITCH_STATES.ON
                  : VIDABOO_CONSTANTS.SWITCH_STATES.OFF
              }
            />
          </div>

          <div className="es-unsubscribe-body-description">
            We’ll stop sending you the weekly digest emails once you
            unsubscribe. You can turn them on in the notifications settings
          </div>
        </div>
      </div>
    </div>
  );
};

EmailOptOutScreen.contextType = AppContext;
export default EmailOptOutScreen;
